import { CdkScrollable } from '@angular/cdk/scrolling'
import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'
import { Data } from '@angular/router'
import { LayoutService } from '@ftr/foundation'
import { FooterLoggedOutComponent, HeaderLoggedOutComponent } from '@ftr/ui-core'

@Component({
  selector: 'ftr-app-layout-no-sidenav',
  templateUrl: './app-layout-no-sidenav.component.html',
  styleUrls: ['./app-layout-no-sidenav.component.css'],
  imports: [CommonModule, HeaderLoggedOutComponent, CdkScrollable, FooterLoggedOutComponent],
})
export class AppLayoutNoSideNavComponent {
  routeData = input({} as Data | undefined)

  protected readonly appContentWindowSelector = LayoutService.CONTENT_WINDOW_CLASS
  protected readonly appContentWindowSelectorGreyBackground = `${this.appContentWindowSelector}--grey-background`
}
